// @flow

import * as React from 'react';
import { noop } from 'lodash';

import { isBrowser } from '@zapier/common-utils';

type Props = {|
  /** The component to protect `Node.removeChild` for. */
  children: React.Node,
|};

let REQUESTS = 0;

const originalRemoveChild = isBrowser() ? Node.prototype.removeChild : noop;

// using function to have access to global scope
function protect() {
  // only when we're the first
  if (!isBrowser() || REQUESTS !== 0) {
    return;
  }

  REQUESTS++;

  // $FlowFixMe Intentionally monkepatching.
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
}

function revert() {
  // only when we're the only one left
  if (!isBrowser() || REQUESTS !== 1) {
    return;
  }

  REQUESTS--;

  // $FlowFixMe Intentionally monkepatching.
  Node.prototype.removeChild = originalRemoveChild;
}

class ProtectRemoveChild extends React.Component<Props> {
  componentDidMount() {
    if (this.props.children) {
      protect();
    }
  }

  componentWillUnmount() {
    revert();
  }

  componentDidUpdate(prevProps: Props) {
    if (!!prevProps.children !== !!this.props.children) {
      if (this.props.children) {
        protect();
      } else {
        revert();
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default ProtectRemoveChild;
